import React from "react";
import "./Sidebar.css";
import logo from "./logo.png"; // ou ton logo
import { UserList,SignOut ,FileText,UserPlus,UserCircleDashed,FilePlus} from "@phosphor-icons/react";

function Sidebar({ isOpen = true, onNavigate, onLogout }) {
  return (
    <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      <div className="sidebar-header">
        <img src={logo} alt="Logo" className="sidebar-logo" />
        <span>Solution Devis</span>
      </div>
      <ul className="sidebar-menu">
        <li style={{display: "flex", alignItems: "center", gap: "10px", justifyContent: "start"}} onClick={() => onNavigate("profile")}><UserCircleDashed size={20} color="#1a1a1a" weight="duotone" /> <span className="sidebar-item-label">Profil</span></li>
        <li style={{display: "flex", alignItems: "center", gap: "10px", justifyContent: "start"}} onClick={() => onNavigate("addClient")}><UserPlus size={20} color="#1a1a1a" weight="duotone" /> <span className="sidebar-item-label">Créer un client</span></li>
        <li style={{display: "flex", alignItems: "center", gap: "10px", justifyContent: "start"}} onClick={() => onNavigate("listClients")}><UserList size={20} color="#050505" weight="duotone" /> <span className="sidebar-item-label">List des clients</span></li>
        
        <li style={{display: "flex", alignItems: "center", gap: "10px", justifyContent: "start"}} onClick={() => onNavigate("createDevis")}><FilePlus size={20} color="#1a1a1a" weight="duotone" /> <span className="sidebar-item-label">Créer un devis</span></li>
        <li style={{display: "flex", alignItems: "center", gap: "10px", justifyContent: "start"}} onClick={() => onNavigate("listDevis")}><FileText size={20} color="#1a1a1a" weight="duotone" /> <span className="sidebar-item-label">Liste des devis</span></li>
        <li style={{display: "flex", alignItems: "center", gap: "10px", justifyContent: "start"}} onClick={onLogout}><SignOut size={20} weight="duotone" /> <span className="sidebar-item-label">Se déconnecter</span></li>
        
      </ul>
      
    </div>
  );
}

export default Sidebar;
